import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const getContentScoringConfigTemplate = (callback) => {
  return async (dispatch) => {
    dispatch({ type: 'GETTING_CONTENT_SCORING_CONFIG_TEMPLATE' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.get(
            `/us/template/content-scoring-config`,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'GETTING_CONTENT_SCORING_CONFIG_TEMPLATE_DONE',
              payload: {
                contentScoringConfig: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'GETTING_CONTENT_SCORING_CONFIG_TEMPLATE_FAILED',
              payload: `Failed to fetch content scoring config templates`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'GETTING_CONTENT_SCORING_CONFIG_TEMPLATE_FAILED',
            payload: `Failed to fetch content scoring config templates`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'GETTING_CONTENT_SCORING_CONFIG_TEMPLATE_FAILED',
        payload: `Failed to fetch content scoring config templates`,
      });
    }
  };
};

export default getContentScoringConfigTemplate;
